<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.procedimentoConsolidado"
            ref="RkmDataTable"
            sort-by="unidadeNome"
            search-by="unidadeNome"
        >
            <template v-slot:cell(procedimento)="row">
                <span
                    :title="row.item.procedimentoNome"
                    v-rkm-tooltip.hover
                >
                    {{ row.item.procedimentoCodigo | formatProcedimento }}
                </span>
            </template>

            <template v-slot:cell(ocupacao)="row">
                <span
                    :title="row.item.ocupacaoNome"
                    v-rkm-tooltip.hover
                >
                    {{ row.item.ocupacaoCodigo }}
                </span>
            </template>

            <template v-slot:cell(actions)="row">
                <rkm-button
                    @click="$refs.Modal.open(row.item)"
                    color="primary"
                    small
                    title="Visualizar"
                >
                    <rkm-icon icon="eye" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <Modal
            @close="$refs.RkmDataTable.refresh()"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './components/lancamento/Modal'

// Filters.
import formats from '@/filters/formats'

// Mixins.
import { repository } from '@/mixins'

export default {
    components: { Modal },
    created() {
        this.repositories = {
            procedimentoConsolidado: this.getConectaSusRepository('bpa.procedimentoConsolidado'),
        }
    },
    data: () => ({
        fields: [
            { name: 'origem', key: 'origem', label: 'Origem', searchable: true, sortable: true },
            { name: 'unidadeNome', key: 'unidadeNome', label: 'Unidade', searchable: true, sortable: true },
            { name: 'competencia', key: 'competencia', label: 'Competência', searchable: true, sortable: true },
            { name: 'procedimentoCodigo', key: 'procedimento', label: 'Procedimento', searchable: true, sortable: true },
            { name: 'ocupacaoCodigo', key: 'ocupacao', label: 'CBO', searchable: true, sortable: true },
            { name: 'quantidade', key: 'quantidade', label: 'Quantidade' },
            { name: 'idade', key: 'idade', label: 'Idade' },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    filters: {
        ...formats,
    },
    methods: {
        refresh() {

            this.$refs.RkmDataTable.refresh()
        },
    },
    mixins: [ repository ],
}
</script>